import * as angular from 'angular';
import Raven = require('raven-js');
import appModule from './app/app.module';
import './style/app.scss';
import './style/lesstest.less';
import './style/styles.css';
import './vendor';

const ravenPlugin = require('raven-js/plugins/angular');

// perform initializations that must be done before angular is started
/**
 * @param {?string} sentryDsn
 */
function initSentry(sentryDsn?: string) {
    if (sentryDsn === null || sentryDsn === undefined || sentryDsn === '') {
        console.info('No sentry_dsn configured; sentry will be disabled (frontend)');
        return;
    }

    Raven.config(sentryDsn)
        .addPlugin(ravenPlugin, angular)
        .install();
    Raven.setEnvironment(ENV);
    Raven.setRelease(VERSION);
    console.log('sentry was isntalled with key ', sentryDsn);

}

initSentry(SENTRY_DSN);

//Start Angular application
angular.element(document).ready(function () {
    angular.bootstrap(document, [appModule.name], {
        strictDi: true
    });
});



// WEBPACK FOOTER //
// ./src/bootstrap.ts